import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import type { membershipApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

const errorBadRequest: membershipApi.ErrorBadRequest = {
  status: 400,
  title: 'Errore Bad Request',
  type: 'urn:badreq',
  rc: 101,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const userSelfRegistration = http.post<object, any, undefined>(
  apiBaseUrl + '/users/self-registration',
  async ({ request }) => {
    const body = await request.json()

    // Verifico se l'utente è già registrato (simulazione)
    const existingUsers = [
      { registrationNumber: '12345', email: 'mario.rossi@example.com', fiscalCode: 'RSSMRA80A01H501U' },
      { registrationNumber: '67890', email: 'luigi.verdi@example.com', fiscalCode: 'VRDLGU85A01H501Z' },
    ]

    // Controllo conflitti - utente già esistente
    if (
      existingUsers.some(
        (user) =>
          user.registrationNumber === body.userRegistrationNumber ||
          user.email === body.userEmail ||
          user.fiscalCode === body.fiscalCode,
      )
    ) {
      const errorConflict: membershipApi.ErrorConflict = {
        status: 409,
        title: 'Errore: utente già registrato',
        type: 'urn:conflict',
        rc: 409,
      }
      return HttpResponse.json(errorConflict, { status: 409 })
    }

    // Controllo validità dei dati
    if (
      !body.userRegistrationNumber ||
      !body.userEmail ||
      !body.firstName ||
      !body.lastName ||
      !body.userBirthDate ||
      !body.fiscalCode ||
      !body.userGender
    ) {
      return HttpResponse.json(errorBadRequest, { status: 400 })
    }

    console.log('Utente registrato con successo:', body)

    // Registrazione riuscita
    return HttpResponse.text(undefined, { status: 204 })
  },
)
